import TabItem from "./TabItem/TabItem";
import {useEffect, useState} from "react";
import {setActivePage} from "../../../redux/actions/lobby/actions";
import {useDispatch, useSelector} from "react-redux";
import {TABS} from "../../../constants/index.jsx";
import {useTranslation} from "react-i18next";

function Tabs({tabItems}) {
    const dispatch = useDispatch();
    const page = useSelector(state => state.lobby.activePage);
    const [selectedTabIndex, setTabIndex] = useState(0);
    const {t} = useTranslation();

    useEffect(() => {
        if (page === 'Tournament' && selectedTabIndex !== 1) {
            setTabIndex(1);
        }
        if (page === 'Cash' && selectedTabIndex !== 0) {
            setTabIndex(0);
        }
    }, [page, selectedTabIndex, setTabIndex]);

    const handleTabClick = (name, index) => {
        dispatch(setActivePage({activePage: name}))
        setTabIndex(index)
    }

    const isTabActive = TABS.includes(page)

    return (
        <div className={`tabs tabs--${tabItems?.length}`}>
            {
                tabItems?.map((item, index) => {
                    return <TabItem
                        key={index}
                        item={t(`tabs.${item}`)}
                        active={isTabActive && selectedTabIndex === index}
                        onClick={() => handleTabClick(item, index)}
                    />
                })
            }
            {isTabActive && <span className={`toggle active-${selectedTabIndex + 1}`}></span>}
        </div>)
}

export default Tabs

